import React from 'react';
import image from '../../../Assets/Cards/deviceWireframe.webp';
import AppPart from '../../Shared/AppPart/AppPart';

function Device(){
    return(
        <>
        <AppPart 
        image={image}
        title="Wireframe for any device"
        desc="Go from idea to wireframe within minutes for any device, iPhone, iPad, Android and desktop.
       Perfect for the early stages of the design process when you’re trying to form your concept into something tangible and translate it to your team, clients or stakeholders."
        />
        </>
    )
};
export default Device ;